/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';
import type { IAPI } from '../../apiResponse';
import { createApiResponseSchema } from '../../apiResponse';

const removeSocialClipDataSchema = z.object({
  removed: z.boolean(),
  challengeUnlinked: z.boolean(),
});

export interface IRemoveSocialClipV1Data {
  removed: boolean;
  challengeUnlinked: boolean;
}

export const removeSocialClipV1ResponseSchema = createApiResponseSchema(
  removeSocialClipDataSchema,
) as z.ZodSchema<IAPI<IRemoveSocialClipV1Data>>;

export type IRemoveSocialClipV1Response = IAPI<IRemoveSocialClipV1Data>;
